module.exports = "<jujo_component specialized=\"true\" comp=\"common_group/view_file\"></jujo_component>"